import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=6e108eab&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"
import style0 from "./delivery.vue?vue&type=style&index=0&id=6e108eab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e108eab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e108eab')) {
      api.createRecord('6e108eab', component.options)
    } else {
      api.reload('6e108eab', component.options)
    }
    module.hot.accept("./delivery.vue?vue&type=template&id=6e108eab&scoped=true", function () {
      api.rerender('6e108eab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/delivery.vue"
export default component.exports